import React from "react";
import { Navigate } from "react-router-dom";
import { useAdminAuth } from "@/context/AdminAuthContext";
import { Loader2 } from "lucide-react";
import usePageMeta from "@/hooks/usePageMeta";

const AdminRoute = ({ children }) => {
    const { isAuthenticated, loading } = useAdminAuth();

    // Admin pages must never be indexed by search engines.
    usePageMeta({
        title: "Administration — Atelier AX",
        description: "Espace d'administration Atelier AX.",
        noindex: true,
    });

    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-neutral-50">
                <Loader2 className="w-8 h-8 animate-spin text-[#d4af37]" />
            </div>
        );
    }

    if (!isAuthenticated) {
        return <Navigate to="/admin/login" replace />;
    }

    return children;
};

export default AdminRoute;
